<template>
  <!-- 摄像头采集 -->
  <div class="camera-collection-img">
    <gat-head class="training-head"></gat-head>
    <div class="camera-collection-container">
      <div class="nav-head">
        <div class="nav-head-left">摄像头采集</div>
        <div class="nav-head-right">
          <div class="go-to-dataset" @click="onBlack">
            <i class="el-icon el-icon-right"></i>
            <span>返回</span>
          </div>
        </div>
      </div>
      <!-- 摄像头 -->
      <div class="camera-configuration">
        <div class="div-configuration">
          <h6>数据采集配置</h6>
          <div class="div-row">
            <p>
              <span>执行间隔（毫秒）：</span>
              <el-input-number
                v-model.trim="dataConfiguration.intervalTime"
                @blur="numberFunction('intervalTime', dataConfiguration.intervalTime)"
                placeholder="请输入执行间隔"
                :min="200"
                :max="5000"
                maxlength="10"
                size="mini"
                :controls="false"
                @keyup.enter.native="numberFunction('intervalTime', dataConfiguration.intervalTime)"
              ></el-input-number>
            </p>
            <p><span></span><span class="tips">* 执行间隔范围须为200~5000之间的数值。</span></p>
          </div>
          <div class="div-row">
            <p>
              <span>采集数量（张数）：</span>
              <el-input-number
                v-model.trim="dataConfiguration.collectionQuantity"
                @blur="numberFunction('collectionQuantity', dataConfiguration.collectionQuantity)"
                placeholder="请输入采集数量"
                :min="20"
                :max="200"
                maxlength="10"
                size="mini"
                :controls="false"
                @keyup.enter.native="numberFunction('collectionQuantity', dataConfiguration.collectionQuantity)"
              ></el-input-number>
              <span class="quantity-target">{{Pictures.total}} / {{dataConfiguration.collectionQuantity}}</span>
            </p>
            <p><span></span><span class="tips">* 采集数量须为20~200之间的数值。</span></p>
          </div>
          <div class="div-row">
            <p>
              <span>自动采集：</span>
              <el-switch
                v-model="dataConfiguration.switchCollection"
                active-color="#4c88ff"
                inactive-color="#DCDFE6"
                @change="switchChange">
              </el-switch>
              <el-button type='primary' size='small' icon="el-icon-camera" @click="takePhone" v-show="!dataConfiguration.switchCollection">手动采集</el-button>
            </p>
            <p><span></span><span class="tips">* 打开开关，摄像头将自动采集数据</span></p>
          </div>
          <canvas id='canvas' width="400" height="300"></canvas>
        </div>
        <div class="div-video">
          <h6>摄像头画面</h6>
          <div class="content-video">
            <video id="video" width="400" height="300"></video>
          </div>
        </div>
      </div>

      <!--文件列表 -->
      <div class="dataset-file-list">
        <!-- <div class="list-head">
          <div>
            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
          </div>
          <div class="add-button">
            <el-button type="primary" size="small" @click="addFile('0')">批量添加</el-button>
            <el-button type="primary" size="small" @click="addFile('1')">全部添加</el-button>
          </div>
        </div> -->
        <div class="list-head" >
          <div>
            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
            <span @click="addFile('0')">批量添加</span>
            <span @click="addFile('1')">全部添加</span>
            <span @click="onBatchDelete">批量删除</span>
            <span @click="onDeleteAll">全部删除</span>
          </div>
          <div class="img-tips">当前{{pageType==1 && modelType==1? '标签' : '数据集'}}还可添加 {{modelType==1 ? 200-fileNumAll : 3000-fileNumAll}} 张图片</div>
        </div>
    
        <div class="picture-box">
          <ul class="pictures">
            <li class="no-data" v-if="Pictures.records && Pictures.records.length === 0">
              <img :src="emptyImgUrl" alt="">
              <span>{{ '当前无数据，开始采集吧~' }}</span>
            </li>
            <li
              class="picture-item"
              v-for="(item, idx) in Pictures.records"
              :key="idx"
            >
              <i class="preview-icon icon-see-img" @click="onFilePreview(item.fileUrl)" title="预览"></i>
              <figure>
                <img class="img" :src="item.fileUrl" alt="" />
              </figure>
              <div class="btns">
                <button
                  class="btn-delete"
                  @click="activeDeletePopup(item.fileId, idx)"
                >
                  删除
                </button>
                <button
                  class="btn-primary"
                  @click="activeRenamePopup(item, idx)"
                >
                  重命名
                </button>
              </div>
              <!-- 勾选框 -->
              <el-checkbox
                class="checkbox"
                v-model="item.checked"
                @change="handleChecked(item, idx)"
              ></el-checkbox>
              <div class="title ellipsis" :title="item.fileName">
                {{ item.fileName }}
              </div>
            </li>
          </ul>
          <!-- 分页 -->
          <div class="pagination">
            <el-pagination
                @current-change="handleCurrentChange"
                background
                :current-page.sync="currentPage"
                :page-size="20"
                :pager-count="5"
                layout="slot, prev, pager, next"
                :total="Pictures.total"
              >
              </el-pagination>
          </div>
        </div>
        <!-- 弹窗集 -->
        <div class="popup-list">
          <!-- 上传图片提示 -->
          <model-training-upload-tips
            :modelType="modelType"
            :popupActive="popupActive"
            @confirmUploadTip="confirmUploadTip"
            @cancelPopup="cancelPopup"
            @uploadNoTipChange="uploadNoTipChange"
          ></model-training-upload-tips>
    
          <!-- 删除 -->
          <gat-popup
            :class="[
              'popup-delete popup-delete-2',
              popupActive === 'batch_add' || popupActive === 'all_add' || popupActive === 'delete' || popupActive === 'batch_delete' || popupActive === 'all_delete'
                ? 'on' : 'off',
            ]"
            :title="''"
            :primary-button="'确定'"
            @cancel="cancelPopup"
            @confirm="deleteOperate"
          >
            <template v-slot:content>
              <div class="popup-del-cnt">
                <div class="head">
                  <i class="icon-box">
                    <icon-base
                      class="icon-info-help"
                      :icon-name="Icons.InfoHelp.iconName"
                      v-bind="Icons.InfoHelp"
                    >
                      <icon-info-help class="path-icon-info-help" />
                    </icon-base>
                  </i>
                  <span v-show="popupActive === 'batch_delete'" class="title">
                    {{`确定批量删除所选${modelTypeCompany(modelType)}吗？`}}
                  </span>
                  <span v-show="popupActive === 'all_delete'" class="title">
                    {{`确定删除全部${modelTypeCompany(modelType)}吗？`}}
                  </span>
                  <span v-show="popupActive === 'delete'" class="title">
                    {{`确定删除此${modelTypeCompany(modelType)}吗？`}}
                  </span>
                  
                  <span v-show="popupActive === 'batch_add'" class="title">
                    {{`确定批量添加所选${modelTypeCompany(modelType)}吗？`}}
                  </span>
                  <span v-show="popupActive === 'all_add'" class="title">
                    {{`确定添加全部${modelTypeCompany(modelType)}吗？`}}
                  </span>
                </div>
              </div>
            </template>
          </gat-popup>
    
          <!-- 重命名 -->
          <gat-popup
            :class="['popup-rename', popupActive === 'rename' ? 'on' : 'off']"
            :title="'重命名'"
            @cancel="cancelPopup"
            @confirm="renameOperate"
          >
            <template v-slot:content>
              <el-input placeholder="请输入重命名" v-model.trim="popupData.rename.fileName" maxlength="20" show-word-limit />
            </template>
          </gat-popup>
    
          <!--文件预览-->
          <file-preview
            :modelType="modelType"
            :fileUrl="fileUrl"
            :dialogvisibleview="dialogvisibleview"
            @onClickDialog="dialogvisibleview = false"
          ></file-preview>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DATASETLOBBY from '@/axios/datasetLobby/datasetLobby.js'
import COMMON from "@/axios/common/common.js";
import PRETRAIN from '@/axios/pretrain/pretrain.js'

import GatPopup from '@/components/common/GatPopup'
import IconInfoHelp from '@/components/icons/typography/InfoHelp'
import ModelTrainingUploadTips from '@/components/pretrain/ModelTrainingUploadTips.vue'
import FilePreview from '@/components/pretrain/FilePreview.vue'

import { GetVerifyImgs } from '@/assets/js/mixin/mixinGetVerifyImgs.js'

export default {
  name: "CameraCollectionImg",
  mixins: [GetVerifyImgs],
  components: { GatPopup, IconInfoHelp, ModelTrainingUploadTips, FilePreview },
  props: {},
  data() {
    return {
      photoBaseUrl: window.gtaAiConfig.photoDomain, // 新UC头像基地址
      pageType: '1',// 页面类型：1模型训练，2数据集大厅
      modelType: '1',
      datasetId: '',
      datasetName: '',
      labelId: '',
      fileUrl: '',
      popupActive: '',
      selectCheckAll: false, // 全选所有
      checkAll: false, // 全选当前
      selectFileIdList: [],
      isIndeterminate: false, // 全选当前中间状态
      currentPage: 1, // 分页器当前页面
      Pictures: {
        records: [], // 文件列表
        recordsAll: [], // 文件总列表
        size: 20,
        current: 1,
        total: 0,
      },
      // 采集配置数据
      dataConfiguration: {
        intervalTime: '1000',
        collectionQuantity: '20',
        switchCollection: false,
      },
      upperQuantity: 20,
      timeInterval: null, // 定时器
      imgPreviewUrl: '',
      dialogvisibleview: false,
      // 翻页
      pagination: {
        currentPage: 1,
        pageSize: 20,
        totalCount: 0,
        pagerCount: 5,
      },
      popupData: {
        rename: {
          index: -1,
          fileId: '',
          fileName: '',
        },
        uploadNoTip: false,
        delete: {
          index: -1,
        },
      },
      Icons: {
        InfoHelp: {
          iconName: '',
          viewBox: '0 0 36 36',
          width: '36',
          height: '36',
          // iconColor: "#fff"
        },
      },
      emptyImgUrl: require('@/assets/images/datasetLobby/icon-empty-box.png'),
      formdata: new FormData(),
      clickFlag: false,
      fileNumAll: 0,
      addFileNum: 0,
    }
  },
  computed: {
  },
  watch: {
    // 监听采集的所有图片
    'Pictures.recordsAll'(val) {
      if (val && val.length) {
        this.Pictures.total = val.length;
        this.getFileList(); // 处理文件页
      }
    },
    // 监听当前列表
    'Pictures.records'(val) {
      this.handleCheckedAllState() // 勾选文件改变全部选框状态
    },
    // 监听采集时间间隔
    'dataConfiguration.intervalTime'(val) {
      if (val && val >= 200 && val <= 5000) {
        clearInterval(this.timeInterval);
        this.timeoutFunction(); // 采集图片
      }
    },
    // 监听采集张数
    'dataConfiguration.collectionQuantity'(val) {
      if (val && val >= 20 && val <= 200) {
        clearInterval(this.timeInterval);
        this.timeoutFunction(); // 采集图片
      }
    },
    selectFileIdList(val) {
      // console.log(val)
    },
    Pictures(val) {
      this.currentPage = val.current || 1;
    },
  },
  created() {
    this.pageType = this.$route.query.pageType || '1';
    this.modelType = this.$route.query.modelType || '1';
    this.fileNumAll = Number(this.$route.query.fileNumAll) || 0;
    this.datasetId = this.$route.query.datasetId || '';
    this.datasetName = this.$route.query.datasetName || '';

    if (this.modelType == 1) {
      this.labelId = this.$route.query.labelId || '';
    }
  },
  mounted() {
    // 摄像头
    this.video = document.getElementById('video');
    //画布
    this.canvas = document.getElementById('canvas');
    // 开始调取摄像头权限。
    this.tackPhoto();
  },
  methods: {
    // 采集图片
    timeoutFunction() {
      clearInterval(this.timeInterval);
      // 判断是否开启自动采集
      if (this.dataConfiguration.witchCollection) {
        this.timeInterval = setInterval(() => {
          if (this.Pictures && this.Pictures.recordsAll.length < this.dataConfiguration.collectionQuantity) {
            this.takePhone();
          } else {
            clearInterval(this.timeInterval);
          }
        }, this.dataConfiguration.intervalTime);
      }
    },
    // 自动采集开关
    switchChange(val) {
      this.dataConfiguration.witchCollection = val;
      this.timeoutFunction(); // 采集图片
    },
    // 开始调取摄像头权限。
    tackPhoto() {
      var video = document.querySelector('video');
      var text = document.getElementById('text');
      // 兼容代码
      window.URL = (window.URL || window.webkitURL || window.mozURL || window.msURL);
       
      if (navigator.mediaDevices === undefined) {
        navigator.mediaDevices = {};
      }
      if (navigator.mediaDevices.getUserMedia === undefined) {
        navigator.mediaDevices.getUserMedia = function(constraints) {
          var getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
          if (!getUserMedia) {
            return Promise.reject(new Error('getUserMedia is not implemented in this browser')); // 此浏览器中未实现getUserMedia
          }
          return new Promise(function(resolve, reject) {
            getUserMedia.call(navigator, constraints, resolve, reject);
          });
        }
      } 
       
      //摄像头调用配置
      var mediaOpts = {
        audio: false,
        video: true,
        video: { facingMode: "environment"} // 或者 "user"
        // video: { width: 1280, height: 720 }
        // video: { facingMode: { exact: "environment" } }// 或者 "user"
      }
 
      let that = this;
      navigator.mediaDevices.getUserMedia(mediaOpts).then(function(stream) {
        that.mediaStreamTrack = stream;
        video = document.querySelector('video');
        if ("srcObject" in video) {
          video.srcObject = stream
        } else {
          video.src = window.URL && window.URL.createObjectURL(stream) || stream
        }
        video.play();
      }).catch(function (err) {
        console.log(err)
      });

      this.Pictures = {
        records: [], // 文件列表
        recordsAll: [], // 文件总列表
        size: 20,
        current: 1,
        total: 0,
      }
    },
    numberFunction(type, val) {
      if (type === 'intervalTime') {
        if (val) {
          this.dataConfiguration.intervalTime = val.toString().split('.')[0];
        } else {
          this.dataConfiguration.intervalTime = 1000;
        }
      }
      if (type === 'collectionQuantity') {
        if (val) {
          let quantity = val.toString().split('.')[0];
          if (quantity >= this.Pictures.total) {
            this.upperQuantity = quantity; // 存储上一次设置的采集目标数
            this.dataConfiguration.collectionQuantity = quantity;
          } else {
            setTimeout(() => {
              this.dataConfiguration.collectionQuantity = this.upperQuantity;
              this.$message.error('输入的采集数量不可低于实际已经采集的图片数量哦！');
            }, 100);
          }
        } else {
          this.dataConfiguration.collectionQuantity = this.upperQuantity || 20;
        }
      }
    },
    //点击拍照截图画面
    takePhone() {
      if (this.Pictures.recordsAll.length >= this.dataConfiguration.collectionQuantity) {
        return this.$message.error('采集数量已达设置数量上限！');
      }
      this.canvas.getContext('2d').drawImage(this.video, 0, 0, 400, 300) ;
      let dataurl = this.canvas.toDataURL('image/jpeg'); // Canvas 转换为 DataURL
      let timeStamp = new Date().getTime();
      this.Pictures.recordsAll.unshift({
        fileUrl: dataurl,
        fileName: `${timeStamp}.jpg`,
        fileId: timeStamp,
        checked: false,
      })
    },
    // DataURL 转换为 File
    dataURLtoFile(dataurl, filename) {
    	var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
    	while(n--){
    		u8arr[n] = bstr.charCodeAt(n);
    	}
    	return new File([u8arr], filename, {type:mime});
    },
    // 模型类别单位过滤
    modelTypeCompany(type) {
      if (type == 1 || type == 2) {
        return '图片';
      } else if (type == 3 || type == 4) {
        return '文本';
      } else if (type == 5 || type == 6) {
        return '音频';
      }
    },
    // 返回上一页面
    onBlack() {
      if (this.pageType == 1) {
        let pathType = ''
        if (this.modelType == 1) {
          pathType = 'dataset/classify'
        } else if (this.modelType == 2) {
          pathType = 'dataset/label'
        } else if (this.modelType == 3) {
          pathType = 'dataset/textCategorization'
        } else if (this.modelType == 4) {
          pathType = 'dataset/textAnnotation'
        } else if (this.modelType == 5) {
          pathType = 'dataset/audioCategorization'
        } else if (this.modelType == 6) {
          pathType = 'dataset/audioAnnotation'
        }
        // 去到模型训练
        this.$router.push({
          path: `/pretrain/${this.modelType}/${pathType}`,
          query: { 
            modelType: this.modelType, // 模型训练类型
            datasetName: this.datasetName, // 模型训练数据集名称
            datasetId: this.datasetId, // 模型训练数据集id
          }
        });
      } else {
        this.$router.go(-1);
      }
    },

    // 变量初始状态
    initialState() {
      this.selectCheckAll = false // 全选所有
      this.checkAll = false // 全选当前页
      this.selectFileIdList = [] // 清空选中文件
      this.isIndeterminate = false // 取消全选中间状态
    },
    // 引用数据集添加文件
    addFile(val) {
      if (val == 0 && this.selectFileIdList.length == 0) {
        return this.$message.error(`请先勾选需要添加的${this.modelTypeCompany(this.modelType)}!`);
      }
      if (val == 1 && this.Pictures.records.length == 0) {
        return this.$message.error(`暂无采集的${this.modelTypeCompany(this.modelType)}!`);
      }

      if (val == 0) {
        this.popupActive = 'batch_add';
      }
      if (val == 1) {
        this.popupActive = 'all_add';
      }
    },

    // 全选、全不选
    handleCheckAllChange(val) {
      this.isIndeterminate = false;
      this.checkAll = val;
      // 判断只有一页的情况
      if (this.Pictures.total <= this.Pictures.size) {
        this.selectCheckAll = val; // 全选所有
      }

      let selectFileIdList = [];
      this.Pictures.records.forEach(item => {
        item.checked = val;
        selectFileIdList.push(item.fileId);
      });

      if (val) {
        this.selectFileIdList = selectFileIdList;
      } else {
        this.selectFileIdList = [];
      }
      // console.log('selectFileIdList', this.selectFileIdList)
      this.$forceUpdate(); // 强制刷新数据
    },
    // 勾选文件改变全部选框状态
    handleCheckedAllState() {
      let checkedCount = 0;
      this.Pictures.records.forEach(item => {
        if (item.checked) {
          checkedCount++
        }
      });
      this.checkAll = this.Pictures.records.length && checkedCount === this.Pictures.records.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.Pictures.records.length;

      // 判断只有一页的情况
      if (this.Pictures.total <= this.Pictures.size) {
        if (this.checkAll) {
          this.selectCheckAll = this.checkAll
        } else if (checkedCount == 0) {
          this.selectCheckAll = this.checkAll
        }
      }
    },
    // 勾选框
    handleChecked(value, idx) {
      this.handleCheckedAllState(); // 勾选文件改变全部选框状态

      if (value.checked) {
        // 选中文件添加到列表
        let flag = this.selectFileIdList.every((item, index) => {
          return item !== value.fileId;
        })
        if (flag) {
          this.selectFileIdList.push(value.fileId);
        }
      } else {
        let selectFileIdList = this.selectFileIdList.filter( id => id !== value.fileId);
        this.selectFileIdList = selectFileIdList;
      }
      // console.log('selectFileIdList', this.selectFileIdList)
      this.$forceUpdate() // 强制刷新数据
    },

    // 上传图片
    uploadPictures() {
      let formData = new FormData(),
        modelType = this.modelType,
        fileList = [],
        fileNumAll = this.fileNumAll,
        val = this.popupActive === 'all_add' ? 1 : 0;

      if (val == 1) { // 全部添加
        this.addFileNum = this.Pictures.total;
        fileList = this.Pictures.recordsAll;
      } else { // 批量添加
        this.addFileNum = this.selectFileIdList.length;
        this.selectFileIdList.forEach(fileId => {
          this.Pictures.recordsAll.forEach(itme => {
            if (itme.fileId === fileId) {
              fileList.push(itme);
            }
          });
        });
      }

      // 限制单次上传数量
      if (this.addFileNum > 200) {
        return this.$message.error(`单次添加${this.modelTypeCompany(modelType)}限制200个!`);
      }
      if (fileNumAll + this.addFileNum > 200 && (modelType == 1 || modelType == 3 || modelType == 5 )) {
        return this.$message.error(`单个${this.pageType == 1 ? '分类标签':'数据集'}的${this.modelTypeCompany(modelType)}总数不超过200个，请重新选择哦~`);
      }
      // 限制文件总数    
      if (fileNumAll + this.addFileNum > 3000 && (modelType == 2 || modelType == 4 || modelType == 6 )) {
        return this.$message.error(`单个数据集的${this.modelTypeCompany(modelType)}总数不超过 3000个 ，请重新选择哦~`);
      }

      this.fullscreenLoading = this.$loading({
        lock: true,
        text: `${this.modelTypeCompany(modelType)}上传中请稍等...`,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      fileList.forEach(item => {
        let fileText = '';
        let name = JSON.parse(JSON.stringify(item.fileName));
        if (name.indexOf('.') !== -1) {
          let jpgIndex = name.lastIndexOf('.jpg');
          if (name.length === jpgIndex + 4) {
            fileText = item.fileName;
          } else {
            fileText = `${item.fileName}.jpg`;
          }
        } else {
          fileText = `${item.fileName}.jpg`;
        }

        // let rep = /.jpg|.jpeg|.png|.pjp|.gif/g;
        // repName = item.fileName.indexOf('.jpg') !== -1 ? item.fileName : item.fileName.replace(rep, '.jpg');
        // fileText = /.jpg/g.test(item.fileName) ? item.fileName : `${item.fileName}.jpg`;

        let file = this.dataURLtoFile(item.fileUrl, fileText); // DataURL 转换为 File
        formData.append('file', file);//图片内容
      });

      this.UploadMultipleFileApi(formData); // 上传图片接口调用
    },
    // 上传图片接口调用
    UploadMultipleFileApi(formData) {
      COMMON.UploadMultipleFile(formData).then((result) => {
        // console.log('上传接口返回', result.data)
        if (result.returnCode == 200) {
          let dataList = JSON.parse(JSON.stringify(result.data));
          let imgList = [];

          dataList.forEach((item, index) => {
            // 图片格式大小尺寸区间
            if (item.size && item.size > 4194304) {
              setTimeout(() => {
                this.$message.error(`上传失败，图片名称为${item.fileName}格式过大！`);
              }, index*5);
            } else if (item.width&&item.width > 2048 || item.height&&item.height > 2048 ) {
              setTimeout(() => {
                this.$message.error(`上传失败，图片名称为“${item.fileName}”分辨率大于2048px*2048px！`);
              }, index*5);
            } else if (item.width&&item.width < 64 || item.height&&item.height < 64) {
              setTimeout(() => {
                this.$message.error( `上传失败，图片名称为“${item.fileName}”分辨率小于64px*64px！`);
              }, index*5);
            } else {
              imgList.push(item);
            }
          });
  
          if (imgList.length === 0) {
            this.fullscreenLoading.close(); // 关闭Loading
            this.formdata = new FormData();  // 释放
            return
          }

          // 模型训练页面
          if (this.pageType == 1) {
            // 校验图片jpg|jpeg
            this.verifyImgs(imgList).then(res => {
              if (res.correct && res.correct.length) {
                let data = {
                  datasetId: this.datasetId,
                  datasetImgList: []
                }
                if (this.modelType == 1) { // 图片分类
                  data.labelId = this.labelId;
                  res.correct.forEach(i => {
                    imgList.forEach(j => {
                      if (i.fileUrl.indexOf(`${j.url}`) !== -1) {
                        data.datasetImgList.push({
                          imgUrl: j.url,
                          imgName: j.fileName,
                          imgWidth: j.width,
                          imgHeight: j.height,
                          imgSize: j.size,
                          datasetId: this.datasetId,
                          labelId: this.labelId,
                        });
                      }
                    });
                  });
                }
                if (this.modelType == 2) { // 物体检测
                  res.correct.forEach(i => {
                    imgList.forEach(j => {
                      if (i.fileUrl.indexOf(`${j.url}`) !== -1) {
                        data.datasetImgList.push( {
                          imgUrl: j.url,
                          imgName: j.fileName,
                          imgWidth: j.width,
                          imgHeight: j.height,
                          imgSize: j.size,
                        });
                      }
                    });
                  });
                }
                this.uploadImg(data); // 上传到服务器的文件转存到数据库中
              }
            })
          } 
          // 数据集页面
          if (this.pageType == 2){
            let data = {
              datasetId: this.datasetId,
              datasetType: this.modelType,
              list: []
            };

            // 校验图片jpg|jpeg
            this.verifyImgs(imgList).then(res => {
              if (res.correct && res.correct.length) {
                res.correct.forEach(i => {
                  imgList.forEach(j => {
                    if (i.fileUrl.indexOf(`${j.url}`) !== -1) {
                      data.list.push({
                        fileUrl: j.url,
                        fileName: j.fileName,
                        fileSize: j.size,
                        imgWidth: j.width,
                        imgHeight: j.height,
                      });
                    }
                  });
                });
                this.uploadImg(data); // 上传到服务器的文件转存到数据大厅数据库中
              }
            })
          }
        } else {
          this.$message.error(result.returnMsg);
          this.fullscreenLoading.close(); // 关闭Loading
        }
        this.formdata = new FormData(); // 释放
      }).catch((error)=>{
        this.formdata = new FormData(); // 释放
        this.fullscreenLoading.close(); // 关闭Loading
        this.$message.error('添加失败! 请检查网络是否正常或减少单次添加的文件数!');
      })
    },
    // 存图片
    uploadImg(data) {
      if (this.pageType == 1) {
        // 存图片模型训练数据库中
        PRETRAIN.uploadImgBylabelId(data).then((result) => {
          this.uploadImgFunc(result);
        })
        .catch((error) => {
          this.fullscreenLoading.close() // 关闭Loading
        })
      }
      if (this.pageType == 2) {
        // 存图片数据大厅数据库中
        DATASETLOBBY.uploadFileByDatasetId(data).then((result) => {
          this.uploadImgFunc(result);
        }).catch((error)=>{
          this.fullscreenLoading.close(); // 关闭Loading
        })
      }
    },
    uploadImgFunc(result) {
      if (result.isSuccess) {
        // 上传成功
        this.$message.success(result.returnMsg);
        this.fullscreenLoading.close(); // 关闭Loading
        // TODO:刷新数据
        this.getFileList(); // 处理文件页
        this.fileNumAll = this.fileNumAll + this.addFileNum;
      } else {
        this.$message.error(result.returnMsg);
        this.fullscreenLoading.close(); // 关闭Loading
      }
    },

    // 图片上传说明
    activeUploadTipPopup() {
      this.popupActive = 'uploadtip';
    },
    // 上传提示显示后再进行上传操作
    confirmUploadTip() {
      this.cancelPopup(); // 关闭弹窗
      // TODO:上传图片事件触发
      // this.uploadPicturesToDataset();
    },
    // 上传图片
    uploadNoTipChange(val) {
      this.localStorageUploadTip('save', val);
    },
    // 图片上传说明是否显示存储
    localStorageUploadTip(type, value) {
      if (type === 'save') {
        this.popupData.uploadNoTip = value;
        window.localStorage.setItem(`__upload_tip_type${this.modelType}__`, value);
      } else {
        let uploadNoTip = window.localStorage.getItem(`__upload_tip_type${this.modelType}__`);
        this.popupData.uploadNoTip = uploadNoTip ? uploadNoTip : false;
      }
    },

    // 预览图片
    onFilePreview(imgUrl) {
      this.fileUrl = imgUrl;
      this.dialogvisibleview = true;
    },
    // 批量删除
    onBatchDelete() {
      if (this.selectFileIdList.length === 0) {
        return this.$message.error(`请先勾选需要删除的${this.modelTypeCompany(this.modelType)}！`);
      }
      this.popupActive = 'batch_delete'
    },
    // 全部删除
    onDeleteAll() {
      if (this.Pictures.recordsAll.length === 0) {
        return this.$message.error(`暂无采集的${this.modelTypeCompany(this.modelType)}!`);
      }
      this.popupActive = 'all_delete'
    },
    // 删除
    activeDeletePopup(fileId, index) {
      this.popupActive = 'delete';
      this.popupData.delete.index = index;
    },
    // 添加 / 删除操作
    deleteOperate() {
      // 批量添加 / 全部添加
      if (this.popupActive === 'batch_add' || this.popupActive === 'all_add') {
        this.uploadPictures();
      }

      // 单删
      if (this.popupActive === 'delete') {
        let deleteIndex = this.popupData.delete.index,
         fileId = this.Pictures.records[deleteIndex].fileId;
        this.Pictures.records.splice(deleteIndex, 1);
        this.Pictures.recordsAll = this.Pictures.recordsAll.filter( value => value.fileId !== fileId);
      }
      // 批量删除
      if (this.popupActive === 'batch_delete') {
        this.selectFileIdList.forEach(fileId => {
          this.Pictures.records = this.Pictures.records.filter( value => value.fileId !== fileId);
          this.Pictures.recordsAll = this.Pictures.recordsAll.filter( value => value.fileId !== fileId);
        });
      }
      // 全部删除
      if (this.popupActive === 'all_delete') {
        this.Pictures = {
          records: [], // 文件列表
          recordsAll: [], // 文件总列表
          size: 20,
          current: 1,
          total: 0,
        }
        this.selectFileIdList = [];
      }

      if (this.Pictures.records.length === 0) {
        this.Pictures.current = this.Pictures.current > 1 ? this.Pictures.current - 1 : 1;
      }

      this.timeoutFunction(); // 采集图片
      this.cancelPopup(); // 关闭弹窗
    },

    // 图片重命名
    activeRenamePopup(obj, index) {
      this.popupActive = 'rename';
      this.popupData.rename.index = index;
      this.popupData.rename.fileId = obj.fileId;
      this.popupData.rename.fileName = obj.fileName;

    },
    // 确认重命名
    renameOperate() {
      if (!this.popupData.rename.fileName) {
        return this.$message.error('重命名不能为空');
      }
      if (this.popupData.rename.fileName.length > 20) {
        return this.$message.error('重命名不能超过20个字符');
      }

      let renameIndex = this.popupData.rename.index,
        fileName = this.popupData.rename.fileName;

      this.Pictures.records[renameIndex].fileName = fileName;
      this.cancelPopup(); // 关闭弹窗
    },

    //  取消弹窗
    cancelPopup() {
      this.popupActive = "";
    },
    // 图片翻页
    handleCurrentChange(current) {
      this.Pictures.current = current;
      this.getFileList(); // 处理文件页
    },
    // 处理文件页
    getFileList() {
      let currentPage = this.Pictures.current;
      let pageSize = this.Pictures.size;
      let indexNum = currentPage * pageSize - pageSize;
      let recordsList = [];
      this.Pictures.recordsAll.forEach((item, index) => {
        item.checked = false;
        if (index >= indexNum && index < indexNum+20) {
          recordsList.push(item);
        }
      });
      this.Pictures.records = recordsList;
      this.initialState(); // 勾选变量初始状态
      // console.log('this.Pictures.records', this.Pictures.records)
    },
  },
  beforeDestroy() {
    this.canvas.getContext('2d').clearRect(0, 0, 400, 300);//清除画布
    if (this.mediaStreamTrack) {
      // 关闭摄像头
      this.mediaStreamTrack.getVideoTracks().forEach(function (track) {
        track.stop();
      });
    }
  },
}
</script>

<style lang="scss" scoped>
div {
  box-sizing: border-box;
}
::v-deep.el-checkbox__input.is-checked .el-checkbox__inner,
::v-deep.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #4C88FF;
  border-color: #4C88FF;
}

.camera-collection-img {
  width: 100%;
  // height: 100%;
  min-height: 100%;
  background-color: $background_normal_color;
  padding: 80px 0 60px;
  .camera-collection-container {
    width: 1200px;
    // min-height: calc(100% - 80px);
    margin: 0 auto;
    .nav-head {
      width: 100%;
      height: 60px;
      display: flex;
      align-items: center;
      .nav-head-left {
        color: #333;
        font-size: 12px;
        font-weight: 700;
        flex: 1;
      }
      .nav-head-right {
        .go-to-dataset {
          color: #4c88ff;
          font-size: 14px;
          font-weight: bold;
          cursor: pointer;
          .el-icon-right {
            margin-right: 5px;
            font-weight: bold;
          }
        }
      }
    }
    .camera-configuration {
      width: 100%;
      background-color: #fff;
      box-shadow: 0px 2px 6px 0px rgba(210, 216, 230, 0.6);
      padding: 20px;
      margin-bottom: 10px;
      display: flex;
      .div-configuration,
      .div-video {
        border: 1px solid #E6E9F2;
        h6 {
          text-align: center;
          font-size: 14px;
          font-weight: bold;
          border-bottom: 1px solid #E6E9F2;
          padding: 10px 0;
        }
      }
      .div-video {
        flex: 1;
        display: flex;
        flex-direction: column;
        .content-video {
          flex: 1;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
      .div-configuration {
        width: 500px;
        height: 360px;
        margin-right: 20px;
        overflow: hidden;
        position: relative;
        #canvas {
          position: absolute;
          left: 0;
          bottom: -300px;
        }
        .div-row {
          // width: 100%;
          margin: 20px;
          p {
            height: 30px;
            line-height: 30px;
            display: flex;
            align-items: center;
            flex-wrap: nowrap;
            span:first-child {
              width: 40%;
              text-align: right;
            }
            span:last-child {
              flex: 1;
            }
            .el-switch {
              margin-right: 20px;
            }
            .quantity-target {
              color: #666;
              margin-left: 20px;
            }
          }
          .tips {
            color: red;
            font-size: 12px;
          }
        }
      }
    }
  }
}

.dataset-file-list {
  width: 100%;
  height: 100%;
  background: #FFFFFF;
  box-shadow: 0px 2px 6px 0px rgba(210,216,230,0.6);
  .list-head {
    width: 100%;
    height: 50px;
    line-height: 50px;
    font-size: 14px;
    border-bottom: 1px solid #E6E9F2;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    padding: 0 20px;
    ::v-deep.el-checkbox__label {
      color: #4C88FF;
      padding-left: 5px;
    }
    .img-tips {
      color: #666;
    }
    .add-button {
      display: flex;
    }
    span {
      // color: #4c88ff;
      color: #4C88FF;
      margin-left: 12px;
      cursor: pointer;
    }
    .el-button {
      height: 30px;
      background: #4C88FF;
      border: 1px solid #4C88FF;
      border-radius: 6px;
    }
  }

  .picture-box {
    min-height: 500px;
    background-color: #fff;
    position: relative;
    padding: 20px 0 80px;
    .pictures {
      display: flex;
      flex-wrap: wrap;
      .no-data {
        color: rgb(145, 144, 144);
        width: 300px;
        height: 160px;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
          width: 134px;
          height: 80px;
        }
        span {
          color: #BDC3D2;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          margin-top: 16px;
        }
      }
      .picture-item {
        overflow: hidden;
        position: relative;
        // width: 225px;
        width: 18%;
        margin-left: 20px;
        .preview-icon {
          font-weight: 700;
          position: absolute;
          top: 10px;
          right: 10px;
          z-index: 1;
          cursor: pointer;
        }
        .icon-see-img {
          width: 17px;
          height: 17px;
          background: url("../../assets/images/datasetLobby/icon-see-img.png") no-repeat;
          background-size: 100% 100%;
        }
        figure {
          overflow: hidden;
          width: 100%;
          height: 140px;
          padding: 0;
          margin: 0;
          text-align: center;
          background-color: #e4e8f2;
          &:hover + .btns {
            visibility: visible;
            opacity: 1;
          }
          img {
            width: 100%;
            height: 100%;
            display: inline-block;
          }
        }
        .checkbox {
          position: absolute;
          left: 8px;
          bottom: 55px;
        }
        .btns {
          visibility: hidden;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          box-sizing: border-box;
          // width: 80px;
          height: 140px;
          padding: 28px 72.5px 0;
          margin: 0 auto;
          background-color: rgba(8, 16, 44, 0.7);
          opacity: 0;
          @include transition;
          button {
            width: 80px;
            height: 36px;
            padding: 0;
            border: 0 none;
            outline: 0 none;
            border-radius: 3px;
            margin-bottom: 15px;
            text-align: center;
            line-height: 36px;
            cursor: pointer;
          }
          .btn-delete {
            background-color: $bgc_btn_del_1;
            &:hover {
              background: $bgc_btn_del_1_hover;
            }
            &:active {
              background-color: $bgc_btn_del_1;
            }
          }
          .btn-primary {
            color: $font_white;
            background-color: #4c88ff;
          }
          &:hover {
            visibility: visible;
            opacity: 1;
          }
        }
        .title {
          margin: 0 1.5em 10px;
          text-align: center;
          line-height: 40px;
        }
      }
    }

    .pagination {
      position: absolute;
      right: 0;
      bottom: 0;
      padding: 20px 0;
    }
  }
  
  // 弹窗
  .popup-list {
    .popup-delete,
    .popup-rename,
    .popup-upload-tip {
      &.off {
        display: none;
      }
    }
    .popup-delete {
      &::v-deep .popup-head {
        border-bottom: 0 none;
      }
      .popup-del-cnt {
        overflow: hidden;
        margin-top: -25px;
        .head {
          .icon-box {
            display: inline-block;
            margin-right: 12px;
            vertical-align: middle;
          }
          .title {
            display: inline-block;
            color: #333;
            vertical-align: middle;
          }
        }
        .content {
          padding: 15px 0;
          text-align: center;
        }
      }
    }

    .popup-delete-2 {
      &::v-deep .popup-inner {
        width: 420px;
        height: 200px;
      }
      .popup-del-cnt {
        margin-top: 10px;
        .head {
          text-align: center;
         }
      }
    }
  }
}
</style>
